module.exports = __webpack_public_path__ + "images/premium1-b15634ec13c85b7bec0c5980ca1712df.jpg";